// src/App.js
import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './Components/Layout';
import { UserProvider } from './UserContext'; // Importa UserProvider
import { withAuth } from './hocs/withAuth';

// Importaciones de las páginas
const Login = lazy(() => import('./Pages/Login/Login'));
const Home = lazy(() => import('./Pages/Home/Home'));
const UsersManagement = lazy(() => import('./Pages/UsersManagement'));
const Apps = lazy(() => import('./Pages/AppsManagement'));
const Roles = lazy(() => import('./Pages/RolesManagement'));
const UsersRoles = lazy(() => import('./Pages/UsersRolesManagement'));
const Functionalities = lazy(() => import('./Pages/FunctionalitiesManagement'));
const Paginas = lazy(() => import('./Pages/PaginasManagement')); // Importa la nueva página
const Carreras = lazy(() => import('./Pages/CarrerasManagement')); 
const Docentes = lazy(() => import('./Pages/DocentesManagement')); 
const Novedades = lazy(() => import('./Pages/NovedadesManagement')); 
const Convenios = lazy(() => import('./Pages/ConveniosManagement')); 
const Archivos = lazy(() => import('./Pages/ArchivosManagement')); 
const Mediosdepago = lazy(() => import('./Pages/MediosdepagoManagement')); 
const Menu = lazy(() => import('./Pages/MenuManagement'));

function App() {
  const LayoutWithAuth = withAuth(Layout);
  const HomeWithAuth = withAuth(Home);
  const UsersManagementWithAuth = withAuth(UsersManagement);
  const AppsWithAuth = withAuth(Apps);
  const RolesWithAuth = withAuth(Roles);
  const UsersRolesWithAuth = withAuth(UsersRoles);
  const FunctionalitiesWithAuth = withAuth(Functionalities);
  const PaginasWithAuth = withAuth(Paginas); // Asegúrate de proteger la ruta con autenticación
  const CarrerasWithAuth = withAuth(Carreras); // Asegúrate de proteger la ruta con autenticación
  const DocentesWithAuth = withAuth(Docentes); // Asegúrate de proteger la ruta con autenticación
  const ConveniosWithAuth = withAuth(Convenios); // Asegúrate de proteger la ruta con autenticación
  const NovedadesWithAuth = withAuth(Novedades); // Asegúrate de proteger la ruta con autenticación
  const ArchivosWithAuth = withAuth(Archivos); // Asegúrate de proteger la ruta con autenticación
  const MediosdepagoWithAuth = withAuth(Mediosdepago); // Asegúrate de proteger la ruta con autenticación
  const MenuWithAuth = withAuth(Menu);

  const appStyle = {
    fontFamily: 'Nunito, sans-serif',
  };

  return (
    <UserProvider>
      <div className="App" style={appStyle}>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path='/login' element={<Login />} />
            <Route element={<LayoutWithAuth />}>
              <Route path="/admin/" element={<HomeWithAuth />} />
              <Route path="/admin/users/new" element={<UsersManagementWithAuth />} />
              <Route path="/admin/users/:userId" element={<UsersManagementWithAuth />} />
              <Route path="/admin/users" element={<UsersManagementWithAuth />} />
              <Route path="/admin/settings/apps" element={<AppsWithAuth />} />
              <Route path="/admin/settings/roles" element={<RolesWithAuth />} />
              <Route path="/admin/users_roles" element={<UsersRolesWithAuth />} />
              <Route path="/admin/settings/functionalities" element={<FunctionalitiesWithAuth />} />
              <Route path="/admin/paginas" element={<PaginasWithAuth />} /> {/* Agregar la ruta para Paginas */}
              <Route path="/admin/ofertas/carreras" element={<CarrerasWithAuth />} /> {/* Agregar la ruta para Carreras */}
              <Route path="/admin/ofertas/mediosdepago" element={<MediosdepagoWithAuth />} /> {/* Agregar la ruta para Carreras */}
              <Route path="/admin/docentes" element={<DocentesWithAuth />} /> {/* Agregar la ruta para Carreras */}
              <Route path="/admin/convenios" element={<ConveniosWithAuth />} /> {/* Agregar la ruta para Carreras */}
              <Route path="/admin/novedades" element={<NovedadesWithAuth />} /> {/* Agregar la ruta para Carreras */}
              <Route path="/admin/archivos" element={<ArchivosWithAuth />} /> {/* Agregar la ruta para Carreras */}
              <Route path="/admin/menu" element={<MenuWithAuth />} />
            </Route>
          </Routes>
        </Suspense>
      </div>
    </UserProvider>
  );
}

export default App;
